export default "__VITE_ASSET__508c5cb1__"